import { useMemo } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import PasswordRequirementIndicator from "./PasswordRequirementIndicator";

interface Props {
  password: string;
}

export const PasswordIndicator = ({ password }: Props) => {
  const requirements = useMemo(
    () => [
      {
        message: "Must contain at least 8 characters",
        isRequirementMet: password.length >= 8,
      },
      {
        message: "Must contain at least 1 lowercase character",
        isRequirementMet: (password.match(/[a-z]/g) || []).length >= 1,
      },
      {
        message: "Must contain at least 1 uppercase character",
        isRequirementMet: (password.match(/[A-Z]/g) || []).length >= 1,
      },
      {
        message: "Must contain at least 1 digit",
        isRequirementMet: (password.match(/\d/g) || []).length >= 1,
      },
      {
        message: "Must contain at least 1 symbol",
        isRequirementMet: (password.match(/[^a-zA-Z\d\s]/g) || []).length >= 1,
      },
    ],
    [password]
  );

  const areAllRequirementsMet = useMemo(
    () => requirements.every((req) => req.isRequirementMet),
    [requirements]
  );

  return (
    <Box marginTop={1}>
      {areAllRequirementsMet ? (
        <Grid container>
          <Grid item xs={12}>
            <PasswordRequirementIndicator isRequirementMet>
              You are good to go!
            </PasswordRequirementIndicator>
          </Grid>
        </Grid>
      ) : (
        <Grid container>
          {requirements.map(({ message, isRequirementMet }) => (
            <Grid item xs={12} key={message}>
              <PasswordRequirementIndicator isRequirementMet={isRequirementMet}>
                {message}
              </PasswordRequirementIndicator>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default PasswordIndicator;
